import $ from "jquery";

// spacer size
var navHeight = $('.nav_desktop_b4ba').height();
$('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})



// dropdown-mega
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  console.log("tigger hover");
  $('.nav_desktop_b4ba__dropdown_mega').hide();
  var $li = $(this);
  var id = $(this).attr('id');
  
  if($li.hasClass('dropdown_mega')) {
    $('.mm-' + id).show();
    $('.nav_desktop_b4ba__navbar').addClass('mhover');
    $('.mega_open_background').fadeIn(0);
  }

});

$('.nav_desktop_b4ba').on('mouseleave', function(){
  console.log('tigger close');
  $('.nav_desktop_b4ba__dropdown_mega').hide();
  $('.nav_desktop_b4ba__navbar').removeClass('mhover');
  $('.mega_open_background').fadeOut(0);

});





// // dropdown
// $('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
//   var $li = $(this);
  
//   if($li.hasClass('dropdown')) {
//     $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
//     $li.addClass('show_dropdown');
//   } else {
//     $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
//   }
// });

// leave nav
$('.nav_desktop_b4ba').on('mouseleave', function(){
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
});

// mega open background

